<template>
  <div class="bj">
    <el-breadcrumb separator-class="el-icon-arrow-right" style="font-size: 17px; margin-bottom: 15px;">
      <el-breadcrumb-item :to="{ name: 'idclist' }">IDC列表</el-breadcrumb-item>
      <el-breadcrumb-item>平台网络映射信息</el-breadcrumb-item>
    </el-breadcrumb>
    <div style="float: right">
      <el-button type="primary" v-if="antvButton"
                 style="margin-right: 10px" @click="isShowAntv">隐藏/显示
      </el-button>
      <el-button type="primary" style="margin-right: 10px" @click="TableOrChart">切换视图</el-button>
      <el-select v-model="group" placeholder="请选择分组" style="width: 240px;"
                 clearable @change="selectGroup">
        <el-option
          v-for="(item, index) in groupList"
          :key="index"
          :label="item.groupAlias"
          :value="item.groupuuid"
        ></el-option>
      </el-select>

      <el-select v-model="net" placeholder="请选择网元类型" style="width: 200px;margin-left: 10px"
                 clearable @change="selectNetType">
        <el-option
          v-for="(item, index) in netList"
          :key="index"
          :label="item"
          :value="item"
        ></el-option>
      </el-select>

      <el-checkbox-group v-show="!showTable" v-model="checkList" @change="changeSelected"
                         style="margin-top: 20px;z-index: 10;position: absolute">
        <el-checkbox label="1">展示IDC</el-checkbox>
        <el-checkbox label="2">展示DEV</el-checkbox>
        <el-checkbox label="4">展示SER</el-checkbox>
      </el-checkbox-group>

    </div>

    <div id="drift" @mousedown="mousedown" style="z-index: 10;position: fixed">
      <el-card style="width: 300px;" v-if="showCard">
        <!--      <div slot="header" class="clearfix">-->
        <!--        <span>{{group}}</span>-->
        <!--      </div>-->
        <div style="color: #3e42cc">{{group}}</div>
        <hr style="border:#dedede 1px dashed"/>
        <div>groupID：{{showGroupID}}</div>
        <div>appkey：{{showAppkey}}</div>
        <div>name：{{showCardName}}</div>
        <div>
          路由策略：<br>
          <div style="margin-left: 20px">聚合：{{showJuhe}}<span style="margin-left: 20px">{{showIsRoam}}</span></div>
          <div style="margin-left: 20px"> 会议：{{showMeeting}} <span
            style="margin-left: 20px">{{showIsRoamMeeting}}</span>
          </div>
        </div>
      </el-card>
    </div>


    <div v-show="showTable" style="float: left">
      <el-tree
        :data="tableData"
        node-key="id"
        :expand-on-click-node="false"
        style="color: #2b2b2b;width: 100%">
      <span class="custom-tree-node" slot-scope="{ node, data }">
        <span v-if="node.level==1">
          <span style="display:inline-block;width: 180px">{{ data.moduleType }}</span>
        <span style="margin-left: 30px;width: 200px;">instanceId:{{ data.instanceId }}</span>
        <span style="margin-left: 30px;display:inline-block;width: 100px;">nodeId:{{ data.nodeId }}</span>
        <span style="margin-left: 30px;display:inline-block;width: 150px;">网络平面ID:{{ data.netPlaneId }}</span>
          <span style="padding-left: 5px">
            <el-button type="text" size="normal" @click="ipTip(data.addr)"
                       style="display:inline-block;width: 230px;color: #2b2b2b;margin-left: 30px;font-size: 17px;text-align: left">{{showIp(data.addr)}}</el-button>
          </span>
<!--          <span style="margin-left: 30px;display:inline-block;width: 390px;">-->
<!--            groupID：{{showGroup(data.groupInfos)}}-->
<!--          </span>-->

          <el-button type="text" size="normal" @click="groupTip(data.groupInfos)"
                     style="color: #2b2b2b;font-size: 17px;display:inline-block;text-align: left">
            <span style="white-space: pre-wrap;">groupId：{{showGroup(data.groupInfos)}}</span>
          </el-button>
<!--          <span style="margin-left: 30px">-->
<!--            {{isShowAppkey(data.groupInfos)}}-->
<!--          </span>-->
        </span>

        <span v-if="node.level==2">
          <span style="display:inline-block;margin-left: 30px;width:100px;" v-if="data.relation==1">NAT</span>
          <span style="display:inline-block;margin-left: 30px;width:100px;" v-if="data.relation==2">butelproxy</span>
          <span style="margin-left: 30px;display:inline-block;width: 150px;">网络平面ID:{{ data.netPlaneId }}</span>
          <el-tooltip placement="top" effect="light">
            <div slot="content">
              <div class="content">
                <div>ispId：{{data.ispId}}</div>
              </div>
            </div>
            <span style="margin-left: 30px;display:inline-block;width: 100px;">ISP:{{ data.ispName }}</span>
          </el-tooltip>
          <el-tooltip placement="top" effect="light">
            <div slot="content">
              <div class="content">
                <div>country：{{data.area.country}}</div>
                <div>province：{{data.area.province}}</div>
                <div>city：{{data.area.city}}</div>
                <div>region：{{data.area.region}}</div>
              </div>
            </div>
            <el-button type="text"
                       style="color: #2b2b2b;margin-left: 30px;font-size: 17px;display:inline-block;width: 200px;text-align: left">{{ data.area.address}}</el-button>
          </el-tooltip>

          <el-button type="text" size="normal" @click="ipTip(data.addr)"
                     style="color: #2b2b2b;margin-left: 30px;font-size: 17px;display:inline-block;width: 230px;text-align: left"><span
            style="white-space: pre-wrap;">{{showIp(data.addr)}}</span></el-button>
        </span>
        <span>
        </span>
      </span>
      </el-tree>

<!--      <el-table-->
<!--        :data="tableData"-->
<!--        :show-header="status"-->
<!--        style="width: 100%;margin-bottom: 20px;"-->
<!--        row-key="rowKey"-->
<!--        border-->
<!--        default-expand-all-->
<!--        :tree-props="{children: 'children', hasChildren: 'hasChildren'}">-->
<!--        <el-table-column prop="instanceId" label="instanceId"  width="180"></el-table-column>-->
<!--        <el-table-column prop="nodeId" label="nodeId"  width="180"></el-table-column>-->
<!--        <el-table-column prop="parentGroupId" label="parentGroupId"></el-table-column>-->
<!--      </el-table>-->
    </div>

    <span v-show="!showTable">
      <div id="container" style="z-index: 2"></div>
    </span>


  </div>
</template>

<script>
  import G6 from '@antv/g6';

  export default {
    name: "antv",

    data() {
      return {
        showTable: false,
        antvButton: false,
        status: false,
        groupList: [],
        netList: [],
        relationList: [],
        tableData: [],
        checkList: [],
        topoList: {},
        group: "",
        net: "",
        renderGraph: "",
        showCard: false,
        showCardName: "",
        showGroupID: "",
        showAppkey: "",
        showJuhe: "",
        showMeeting: "",
        showIsRoam: "",
        showIsRoamMeeting: "",
        addrIp: "",
        addrPort: "",
        addrProtocol: "",
        addrExtendInfo: "",
        ipStrHtml: "",
        selectedInstanceId: 0,
        selectedProxyId: 0,
        showAntv: true,
        clickId: ""
      }
    },
    created() {
      this.getGroupList();
      this.getNetList();
      this.getTopo();
    },
    mounted() {
      this.initTopo();
    },
    methods: {
      isShowAntv() {
        let that = this;
        let nodesArr = [];
        if (that.showAntv) {
          if (that.moveList && that.moveList.length > 0) {
            that.moveList.forEach(e => {
              if (!nodesArr.includes(e.source)) {
                nodesArr.push(e.source);
              }
              if (!nodesArr.includes(e.target)) {
                nodesArr.push(e.target);
              }
            });
            that.renderGraph.findAll('node', (node) => {
              if (!nodesArr.includes(node.get('model').id)) {
                that.renderGraph.hideItem(node)
              }
              return true;
            });
          }
          that.showAntv = false;
        } else {
          that.renderGraph.findAll('node', (node) => {
            if (node.get('model').id != "x") {
              that.renderGraph.showItem(node)
            }
            return true;
          });
          that.showAntv = true
        }
      },
      mousedown(event) {
        this.selectElement = document.getElementById('drift');
        var div1 = this.selectElement;
        this.selectElement.style.cursor = 'move';
        // this.isDowm = true
        var distanceX = event.clientX - this.selectElement.offsetLeft;
        var distanceY = event.clientY - this.selectElement.offsetTop;
        // console.log(distanceX)
        // console.log(distanceY)
        document.onmousemove = function (ev) {
          var oevent = ev || event;
          div1.style.top = oevent.clientY - distanceY + 'px';
          div1.style.left = oevent.clientX - distanceX + 'px';
          div1.style.right = 'auto'
        };
        document.onmouseup = function () {
          document.onmousemove = null;
          document.onmouseup = null;
          div1.style.cursor = 'default'
        }
      },
      groupTip(item){
        this.$notify.closeAll();
        if (item && item.length > 0) {
          let groupID = [];
          item.forEach(e => {
            let html =
              "groupId："+"<span>" + e.groupId + "</span>" +"<br>"+
              "appkey："+"<span>" + e.appkey + "</span>" +"<br>"+"<br>";
            groupID.push(html);
          });
          let str = groupID.toString().replace(/,/g, "");

          this.$notify({
            // title: '自定义位置',
            position: 'bottom-right',
            dangerouslyUseHTMLString: true,
            message: str,
            duration: 0,//是否自动关闭
            customClass: 'notifyStyle'
          });
        }
      },
      ipTip(item) {
        this.$notify.closeAll();
        let ipArr = [];
        item.forEach(e => {
          // this.addrIp = e.ip;
          // this.addrPort = e.port;
          // this.addrProtocol = e.protocol;
          // this.addrExtendInfo = e.extendInfo;
          let protocol;
          if (e.protocol==1){
            protocol="UDP"
          } else if (e.protocol==2) {
            protocol="TCP"
          }else {
            protocol="UDP&TCP"
          }
          let html =
            "<span>" + e.ip + "</span>" +
            "<span style='margin-left: 30px'>" + e.port + "</span>" +
            "<span style='margin-left: 30px'>" + protocol + "</span>" +
            "<span style='margin-left: 30px'>" + e.extendInfo + "</span>" + "<br>";
          ipArr.push(html);
        });
        // var reg = /[,，]/g;
        // let str = ipArr.toString().replace(reg, "$&\r\n");
        let str = ipArr.toString().replace(/,/g, "");

        this.$notify({
          // title: '自定义位置',
          position: 'bottom-right',
          dangerouslyUseHTMLString: true,
          message: str,
          duration: 0,//是否自动关闭
          customClass: 'notifyStyle'
        });
      },
      showIp(ipArr) {
        let ipStr = [];
        let showIP = "";
        for (let i = 0; i < ipArr.length; i++) {
          let a = ipArr[i].ip + ":" + ipArr[0].port + "\n";
          ipStr.push(a);
          if (ipStr.length > 1) {
            showIP = ipArr[0].ip + ":" + ipArr[0].port + "...";
          } else {
            showIP = ipArr[0].ip + ":" + ipArr[0].port;
          }

        }
        // this.ipStrHtml =
        // "<span>"+ipStr.toString()+ "</span>";
        return showIP;
      },
      showGroup(item) {
        if (item && item.length > 0) {
          let groupID = [];
          let str = "";
          item.forEach(e => {
            str = e.groupId;
            groupID.push(str);
          });

          let showGroupid;
          if (groupID && groupID.length > 1) {
            showGroupid = groupID[0] + "...";
          } else {
            showGroupid = groupID[0];
          }
          return showGroupid
        }
      },
      // isShowAppkey(item) {
      //   if (item && item.length > 0) {
      //     let appkey;
      //     item.forEach(e => {
      //       appkey = "appkey：" + e.appkey;
      //     });
      //     return appkey
      //   }
      // },

      changeSelected() {
        if (this.clickId != "") {
          if (this.checkList.includes("4")) {
            this.getTopo();

            // const moveEdgeArr = this.renderGraph.findAll('edge', (node) => {
            //   return node.get('model').type == "move-dash";
            // });
            // if (moveEdgeArr && moveEdgeArr.length > 0) {
            //   moveEdgeArr.forEach(e => {
            //     this.renderGraph.removeItem(e);
            //   });
            // }
            // // setTimeout(() => {
            // //   let nodesArr = [];
            //   this.getTopoLine();
            // if (!this.showAntv) {

            //   if (this.moveList && this.moveList.length > 0) {
            //     this.moveList.forEach(e => {
            //       if (!nodesArr.includes(e.source)) {
            //         nodesArr.push(e.source);
            //       }
            //       if (!nodesArr.includes(e.target)) {
            //         nodesArr.push(e.target);
            //       }
            //     });
            //     this.renderGraph.findAll('node', (node) => {
            //       if (!nodesArr.includes(node.get('model').id)) {
            //         this.renderGraph.hideItem(node)
            //       }
            //       return true;
            //     });
            //   }
            // }
            // else {
            //   if (this.moveList && this.moveList.length > 0) {
            //     this.moveList.forEach(e => {
            //       if (!nodesArr.includes(e.source)) {
            //         nodesArr.push(e.source);
            //       }
            //       if (!nodesArr.includes(e.target)) {
            //         nodesArr.push(e.target);
            //       }
            //     });
            //     this.renderGraph.findAll('node', (node) => {
            //       if (!nodesArr.includes(node.get('model').id)) {
            //         this.renderGraph.hideItem(node)
            //       }
            //       return true;
            //     });
            //   }
            // }
            // }, 1);
            // this.clickId="";
          } else {
            this.getTopo();
            this.showAntv = true;
            this.antvButton = false;
            // this.selectedInstanceId = 0;
            // this.selectedProxyId = 0;
            this.clickId = "";
            this.renderGraph.findAll('node', (node) => {
              if (node.get('model').id != "x") {
                this.renderGraph.showItem(node)
              }
              return true;
            });
          }
        } else {
          this.getTopo();
          this.showAntv = true;
          this.antvButton = false;
          // this.selectedInstanceId = 0;
          // this.selectedProxyId = 0;
          this.renderGraph.findAll('node', (node) => {
            if (node.get('model').id != "x") {
              this.renderGraph.showItem(node)
            }
            return true;
          });
        }
      },
      getTopoLine() {
        let status = 0;
        if (this.checkList && this.checkList.length > 0) {
          this.checkList.forEach(e => {
            status += parseInt(e);
          })
        } else {
          status = 0
        }
        let param = {
          projectSourceId: this.group,
          moduleType: this.net,
          status: status,
          instanceId: this.selectedInstanceId,
          butelproxyId: this.selectedProxyId
        };
        const loading = this.$loading({
          lock: true,
          text: '获取中...',
          // spinner: 'el-icon-loading',
          background: 'rgba(55,55,55, 0.4)'
        });

        let that = this;
        this.$axios.post(this.baseUrl3 + 'management3/topo/line', param)
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {
              that.moveList = data.relation;
              if (that.moveList && that.moveList.length > 0) {
                that.moveList.forEach(e => {
                  that.renderGraph.addItem('edge', {
                    source: e.source,
                    target: e.target,
                    type: 'move-dash'
                  }, true);
                });
                // that.renderGraph.paint();
                // that.renderGraph.setAutoPaint(true);
                if (!that.showAntv) {
                  that.renderGraph.findAll('node', (node) => {
                    if (node.get('model').id != "x") {
                      that.renderGraph.showItem(node)
                    }
                    return true;
                  });
                  // that.showAntv=true;
                  let nodesArr = [];
                  if (that.moveList && that.moveList.length > 0) {
                    that.moveList.forEach(e => {
                      if (!nodesArr.includes(e.source)) {
                        nodesArr.push(e.source);
                      }
                      if (!nodesArr.includes(e.target)) {
                        nodesArr.push(e.target);
                      }
                    });
                    that.renderGraph.findAll('node', (node) => {
                      if (!nodesArr.includes(node.get('model').id)) {
                        that.renderGraph.hideItem(node)
                      }
                      return true;
                    });
                  }
                  that.showAntv = false;
                }
              }
            } else {
              that.antvButton = false;
              that.$message({showClose: true, message: msg, type: 'error'});
              console.log(msg)
            }
            loading.close();
          })
          .catch(err => {
            console.log(err);
            loading.close();

          })
      },
      TableOrChart() {
        if (this.showTable) {
          this.showTable = false;
          this.$notify.closeAll();
        } else {
          this.showTable = true;
          this.getTable();
        }
      },
      getTable() {
        let param = {
          projectSourceId: this.group,
          moduleType: this.net,
          status: 0,
          instanceId: !this.antvButton ? 0 : this.selectedInstanceId,
          butelproxyId: !this.antvButton ? 0 : this.selectedProxyId,
        };
        const loading = this.$loading({
          lock: true,
          text: '获取中...',
          // spinner: 'el-icon-loading',
          background: 'rgba(55,55,55, 0.4)'
        });

        let _this = this;
        _this.tableData = [];
        this.$axios.post(this.baseUrl3 + 'management3/topo/table', param)
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {

              // if (data) {
              //   data.forEach((e, idx) => {
              //     e.rowKey = e.netPlaneId + "";
              //     if (e.children) {
              //       e.children.forEach(child => {
              //         child.rowKey = e.netPlaneId + "_" + child.netPlaneId
              //       })
              //     }
              //   })
              // }
              // _this.tableData = data && data.IpList ? data.IpList : [];


              _this.tableData = data;

              // // _this.initTopo();
              // _this.renderGraph.destroy();
              // _this.initTopo();
            } else {
              _this.$message({showClose: true, message: msg, type: 'error'});
              console.log(msg)
            }
            loading.close();
          })
          .catch(err => {
            console.log(err);
            loading.close();
          })
      },
      // refreshTopo(){
      //   this.renderGraph.read(this.topoList);
      //   this.renderGraph.fitView();
      //
      //   var head = this.renderGraph.findById("x");
      //   this.renderGraph.hideItem(head);
      //
      //
      //   this.relationList.forEach(e => {
      //     if (e.isIncreased) {
      //       this.renderGraph.addItem('edge', {
      //         source: e.source,
      //         target: e.target,
      //         type: 'line'
      //       }, true);
      //     }
      //   });
      // },
      getTopo() {
        let status = 0;
        if (this.checkList && this.checkList.length > 0) {
          this.checkList.forEach(e => {
            status += parseInt(e);
          })
        } else {
          status = 0
        }
        let param = {
          projectSourceId: this.group,
          moduleType: this.net,
          status: status,
        };
        const loading = this.$loading({
          lock: true,
          text: '获取中...',
          // spinner: 'el-icon-loading',
          background: 'rgba(55,55,55, 0.4)'
        });

        let _this = this;
        _this.relationList = [];
        this.$axios.post(this.baseUrl3 + 'management3/topo', param)
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {
              let dataObj = {
                "name": "管理平台",
                "type": 10,
                "id": "x",
                "children": data.nodeList
              };
              _this.topoList = dataObj;
              _this.relationList = data.relation;
              // _this.refreshTopo();
              // _this.initTopo();
              _this.renderGraph.destroy();
              _this.initTopo();
              // _this.renderGraph.changeData(_this.topoList);
              // _this.renderGraph.paint();
              // _this.renderGraph.setAutoPaint(true);
              if (this.clickId != "") {
                if (this.checkList.includes("4")) {
                  const moveEdgeArr = this.renderGraph.findAll('edge', (node) => {
                    return node.get('model').type == "move-dash";
                  });
                  if (moveEdgeArr && moveEdgeArr.length > 0) {
                    moveEdgeArr.forEach(e => {
                      this.renderGraph.removeItem(e);
                    });
                  }
                  this.getTopoLine();
                }
              }
            } else {
              _this.$message({showClose: true, message: msg, type: 'error'});
              console.log(msg)
            }
            loading.close();
          })
          .catch(err => {
            console.log(err);
            loading.close();
          })
      },
      selectNetType(e) {
        // this.showAntv = true;
        // this.antvButton = false;
        if (this.showTable) {
          this.getTable()
        } else {
          this.getTopo()
        }
      },
      selectGroup(e) {
        // this.showAntv = true;
        this.showCard = true;
        // this.antvButton = false;
        this.groupList.forEach(item => {
          if (e == item.groupuuid) {
            // this.showName = e.groupname;
            this.showGroupID = item.groupuuid;
            this.showAppkey = item.appkey;
            this.showCardName = item.projectName;
            this.showJuhe = item.strategyDesc;
            this.showMeeting = item.strategyDescMeeting;
            if (item.roam == 1) {
              this.showIsRoam = "漫游"
            } else if (item.roam == 2) {
              this.showIsRoam = "不漫游"
            } else {
              this.showIsRoam = "未设置"
            }
            if (item.roamMeeting == 1) {
              this.showIsRoamMeeting = "漫游"
            } else if (item.roamMeeting == 2) {
              this.showIsRoamMeeting = "不漫游"
            } else {
              this.showIsRoamMeeting = "未设置"
            }
          }
        })
        if (this.showTable) {
          this.getTable()
        } else {
          this.getTopo()
        }
        // this.showCard = true;
        // this.showName = e.groupname;
        // this.showGroupID = e.groupuuid;
        // this.showAppkey = e.appkey;
        // this.showCardName = e.enterpriseName;
        // this.showJuhe = e.strategyDesc;
        // this.showMeeting = e.strategyDescMeeting;
        // if (e.roam == 1) {
        //   this.showIsRoam = "漫游"
        // } else if (e.roam == 2) {
        //   this.showIsRoam = "不漫游"
        // } else {
        //   this.showIsRoam = "未设置"
        // }
        //
        // if (e.roamMeeting == 1) {
        //   this.showIsRoamMeeting = "漫游"
        // } else if (e.roamMeeting == 2) {
        //   this.showIsRoamMeeting = "不漫游"
        // } else {
        //   this.showIsRoamMeeting = "未设置"
        // }
      },
      getNetList() {
        this.$axios.get(this.baseUrl3 + 'management3/config/generatebusinesstype')
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {
              let arr = [];
              data.BusinessTypeInfo.forEach(e => {
                e.ServerType.forEach(item => {
                  arr.push(item)
                });
              });
              let newArr = [];
              for (let i = 0; i < arr.length; i++) {
                if (newArr.indexOf(arr[i]) === -1) {
                  newArr.push(arr[i])
                }
              }
              this.netList = newArr;
            } else {
              this.$message({showClose: true, message: msg, type: 'error'});
              console.log(msg)
            }
          })
          .catch(err => {
            console.log(err)
          })
      },
      getGroupList() {
        var data = {
          "pageNo": 1,
          "pageSize": 50,
          "token": "",
          "keyword": "",
          "appkey": "",
          "deleteFlag": 1
        };
        var _this = this;
        this.$axios.post(this.baseUrl3 + 'management3/source/GetPaasGrouplist', data)
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {
              this.groupList = data.list;
            } else {
              _this.$message({showClose: true, message: msg, type: 'error'});
              console.log(msg)
            }
          })
          .catch(err => {
            console.log(err)
          })
      },
      initTopo() {
        let that = this;
        let data = this.topoList;
        const lineDash = [4, 2, 1, 2];

        //    const tooltip = new G6.Tooltip({
        //      offsetX: 0,
        //      offsetY: 0,
        //      // the types of items that allow the tooltip show up
        //      // 允许出现 tooltip 的 item 类型
        //      itemTypes: ['node', 'edge'],
        //      // custom the tooltip's content
        //      // 自定义 tooltip 内容
        //      getContent: (e) => {
        //        const outDiv = document.createElement('div');
        //        outDiv.style.width = 'fit-content';
        //        //outDiv.style.padding = '0px 0px 20px 0px';
        //        outDiv.innerHTML = `
        //  <div>
        //    <div>名称：${data.name} </div>
        //    <div>ID: ${data.id}</div>
        //  </div>
        // `;
        //        return outDiv;
        //      },
        //    });

        const container = document.getElementById('container');
        const width = container.scrollWidth;
        // const height = document.documentElement.clientHeight;
        // const height = document.documentElement.clientHeight;
        const height = container.scrollHeight || 800;
        //工具栏
        // const toolbar = new G6.ToolBar({
        //   position: {x: 10, y: 10}
        // });
        //提示框
        // const tooltip = new G6.Tooltip({
        //   offsetX: 20,
        //   offsetY: 20,
        // });

        const graph = new G6.TreeGraph({
          container: 'container',
          width,
          height,
          linkCenter: true,
          // plugins: [tooltip],
          plugins: [
            new G6.Tooltip({
              offsetX: 10,
              offsetY: 80,
              formatText: (data) => {
                // data 对应后台返回对应节点的数据，根据需要做展示
                return `<div style="width: 100%;height: 30px;background-color: white;padding:10px;border:1px solid #cecece;border-radius: 10px">
                           <div style="font-size: 15px;color: #3e42cc">名称: ${data.name}</div>
                           <div style="font-size: 15px;color: #3e42cc">ID: ${data.id}</div>
                            </div>`
              },
              // ...
            })
          ],
          modes: {
            default: [
              // {
              {
                //   type: 'collapse-expand',
                //   trigger: 'dblclick',
                //   relayout: false, // 收缩展开后，不重新布局
                //   onChange: function onChange(item, collapsed) {
                //     const data = item.get('model');
                //     data.collapsed = collapsed;
                //     return true;
                //   },
                // },
                type: 'collapse-expand',
                trigger: 'dblclick',
                onChange: function onChange(item, collapsed) {
                  const data = item.get('model');
                  data.collapsed = collapsed;
                  return true;
                },
              },
              // {
              //   // 自定义提示
              //   type: 'tooltip',
              //   // offsetX: 10,
              //   // offsetY: 20,
              //   formatText: (data) => {
              //     // data 对应后台返回对应节点的数据，根据需要做展示
              //     return `<div style="width: 100%;height: 30px;background-color: white;padding:10px;border:1px solid #cecece;border-radius: 10px">
              //              <div style="font-size: 15px;color: #3e42cc">名称: ${data.name}</div>
              //              <div style="font-size: 15px;color: #3e42cc">ID: ${data.id}</div>
              //               </div>`
              //   },
              // },
              'drag-node',
              'drag-canvas',
              'zoom-canvas',
              // 'activate-relations'
            ],
          },
          defaultNode: { // 节点样式修改
            type: 'image', // 设置节点为图片
            size: [20, 20] // 节点大小
          },
          layout: {
            type: 'dendrogram',
            direction: 'LR',
            nodeSep: 20,
            rankSep: 100,
            radial: true,
            // preventOverlap: true,
          },
          defaultEdge: {
            type: "line",
            stroke: "#b5adac",
            // style: {
            //   lineWidth: 1, // 线宽
            // stroke: '#b5adac', // 线的颜色
            //   starArrow: { // 设置终点箭头
            //     path: G6.Arrow.vee(5, 8, 20), // 使用内置箭头路径函数，参数为箭头的 宽度、长度、偏移量（默认为 0，与 d 对应）
            //     d: 20
            //   },
            // }
          },
          animate: true,
          groupByTypes:false
        });

        G6.registerEdge(
          'line-dash',
          {
            afterDraw(cfg, group) {
              // get the first shape in the group, it is the edge's path here=
              const shape = group.get('children')[0];
              let index = 0;
              // Define the animation
              shape.animate(
                () => {
                  index++;
                  if (index > 9) {
                    index = 0;
                  }
                  const res = {
                    lineDash,
                    lineDashOffset: -index,
                  };
                  // returns the modified configurations here, lineDash and lineDashOffset here
                  return res;
                },
                // {
                //   repeat: true, // whether executes the animation repeatly
                //   duration: 3000, // the duration for executing once
                // },
              );
            },
          },
          'line'
        );

        G6.registerEdge(
          'move-dash',
          {
            afterDraw(cfg, group) {
              // get the first shape in the group, it is the edge's path here=
              const shape = group.get('children')[0];
              let index = 0;
              shape.attr('stroke', '#50c6f2');
              shape.attr('lineWidth', '3');
              // Define the animation
              shape.animate(
                () => {
                  index++;
                  if (index > 9) {
                    index = 0;
                  }
                  const res = {
                    lineDash,
                    lineDashOffset: -index,
                  };
                  // return the params for this frame
                  return res;
                },
                {
                  repeat: true,
                  duration: 300,
                },
              );
            },
          },
          'line',
        );

        let relationMap = new Map();
        if(that.relationList && that.relationList.length>0){
          this.relationList.forEach(e => {
            let key = e.source + ":" + e.target;
            relationMap.set(key, e.type)
          });
        }



        // 设置节点样式
        graph.node(function (node) {
          if (node.nodeType == 0) {
            return {
              label: node.name,
              type: "image",
              size: [30, 30],
              img: require('@/assets/pubCloud.png'),
              labelCfg: {
                style: {
                  fontSize: 10,
                },
              },
            };

          } else if (node.nodeType == 1) {
            return {
              label: node.name,
              type: "image",
              size: [30, 30],
              img: require('@/assets/priCloud.png'),
              labelCfg: {
                style: {
                  fontSize: 10,
                },
              },

            }

          } else if (node.nodeType == 2) {
            return {
              label: node.name,
              type: "image",
              size: [30, 30],
              img: require('@/assets/IDC.png'),
              labelCfg: {
                style: {
                  fontSize: 10,
                },
              },
            }
          } else if (node.nodeType == 3) {
            return {
              label: node.name,
              type: "image",
              size: [30, 30],
              img: require('@/assets/underIDC.png'),
              labelCfg: {
                style: {
                  fontSize: 10,
                },
              },
            }
          } else if (node.nodeType == 4) {
            return {
              label: node.name,
              type: "image",
              size: [30, 30],
              img: require('@/assets/dev.png'),
              labelCfg: {
                style: {
                  fontSize: 10,
                },
              },
            }
          } else if (node.nodeType == 5) {
            return {
              label: node.name,
              type: "image",
              size: [30, 30],
              img: require('@/assets/service.png'),
              labelCfg: {
                style: {
                  fontSize: 10,
                },
              },
            }
          } else if (node.nodeType == 6) {
            return {
              label: node.name,
              type: "image",
              size: [30, 30],
              img: require('@/assets/proxy6.png'),
              labelCfg: {
                style: {
                  fontSize: 10,
                },
              },
            }
          } else if (node.nodeType == 7) {
            return {
              label: node.name,
              type: "image",
              size: [30, 30],
              img: require('@/assets/proxyService.png'),
              labelCfg: {
                style: {
                  fontSize: 10,
                },
              },
            }
          } else {
            return {
              label: node.name,
              size: [30, 30],
              labelCfg: {
                style: {
                  fontSize: 10,
                },
              },
            };
          }
          // if (node.depth == 0) {
          //   return {
          //     label: node.name,
          //   };
          // } else if (node.depth == 1) {
          //   return {
          //     label: node.name,
          //     type: "image",
          //     // img: require('@/assets/cloud2.png')
          //   };
          // } else {
          //   return {
          //     label: node.name,
          //   };
          // }

        });


        //根据条件设置不同的连线样式
        graph.edge(function (node) {
          if (relationMap.get(node.id) == 12) {
            return {
              style: {
                lineWidth: 1, // 线宽
                // stroke: '#b5adac', // 线的颜色
                startArrow: { // 设置终点箭头
                  path: G6.Arrow.vee(5, 5, 15), // 使用内置箭头路径函数，参数为箭头的 宽度、长度、偏移量（默认为 0，与 d 对应）
                  d: 15,
                  // fill: '#b5adac'
                },
                endArrow: {
                  path: G6.Arrow.circle(10, 20, 10), // 使用内置箭头路径函数，参数为箭头的 宽度、长度、偏移量（默认为 0，与 d 对应）
                  d: 10,
                  fill: '#f00',
                  stroke: '#0f0',
                  opacity: 0,
                  lineWidth: 3,
                },
              }
            }
          } else if (relationMap.get(node.id) == 8) {
            return {
              type: "line-dash",
              style: {
                lineWidth: 1,
                // stroke: '#b5adac',
              },
            }
          } else {
            return {
              style: {
                type: "line",
                // stroke:"#b5adac"
              }
            }
          }
        });


        //边上的点击事件
        // graph.on('edge:click', (e) => {
        //   // 先将所有当前有 click 状态的边的 click 状态置为 false
        //   const clickEdges = graph.findAllByState('edge', 'click');
        //   clickEdges.forEach((ce) => {
        //     graph.setItemState(ce, 'click', false);
        //   });
        //   if (e.item._cfg.id=="Modeling Methods:Classification") {
        //     const edgeItem = e.item;
        //     // 设置目标边的 click 状态 为 true
        //     graph.setItemState(edgeItem, 'click', true);
        //     this.$confirm('这里展示信息！', '信息', {
        //       confirmButtonText: '确定',
        //       cancelButtonText: '取消',
        //     }).then(() => {
        //       this.$message({
        //         type: 'success',
        //         message: '已确认!'
        //       });
        //     }).catch(() => {
        //       this.$message({
        //         type: 'info',
        //         message: '已取消'
        //       });
        //     });
        //   }
        //
        // });


        that.renderGraph = graph;

        graph.data(data);


        graph.render();
        graph.fitView();

        //隐藏节点及其边
        var head = graph.findById("x");
        graph.hideItem(head);


        if(that.relationList && that.relationList.length>0){
          that.relationList.forEach(e => {
            if (e.isIncreased) {
              graph.addItem('edge', {
                source: e.source,
                target: e.target,
                type: 'line'
              }, true);
            }
          });
        }


        graph.on('node:click', function (e) {
            //清空虚线状态
            const moveEdgeArr = graph.findAll('edge', (node) => {
              return node.get('model').type == "move-dash";
            });
            if (moveEdgeArr && moveEdgeArr.length > 0) {
              moveEdgeArr.forEach(e => {
                graph.removeItem(e);
              });
            }
            let selectedNodeType = e.item._cfg.model.nodeType;
            that.selectedInstanceId = e.item._cfg.model.instanceId;
            that.selectedProxyId = e.item._cfg.model.proxyId;

            //判断当前点击的节点是否是“服务”
            if (selectedNodeType == 5 || selectedNodeType == 7) {
              //判断当前点击的节点是否是选中状态  若为选中状态则取消选中，否则选中
              // if (that.showAntv) {
              if (that.clickId != "") {
                if (that.clickId == e.item._cfg.model.id) {
                  that.antvButton = false;
                  that.renderGraph.findAll('node', (node) => {
                    if (node.get('model').id != "x") {
                      that.renderGraph.showItem(node)
                    }
                    return true;
                  });
                  that.clickId = "";
                  if (!that.showAntv) {
                    that.showAntv = true;
                  }
                } else {
                  that.getTopoLine();
                  that.clickId = e.item._cfg.model.id;
                  that.antvButton = true;
                }
              } else {
                that.getTopoLine();
                that.clickId = e.item._cfg.model.id;
                that.antvButton = true;
              }
              // }

              // else {
              //   if (that.clickId != "") {
              //     if (that.clickId == e.item._cfg.model.id) {
              //       that.antvButton = false;
              //       that.renderGraph.findAll('node', (node) => {
              //         if (node.get('model').id != "x") {
              //           that.renderGraph.showItem(node)
              //         }
              //         return true;
              //       });
              //       that.clickId = "";
              //       that.showAntv=true;
              //     } else {
              //       that.clickId = e.item._cfg.model.id;
              //       that.antvButton = true;
              //       that.getTopoLine();
              //     }
              //   } else {
              //     that.clickId = e.item._cfg.model.id;
              //     that.antvButton = true;
              //     that.getTopoLine();
              //   }
              // }
            } else {
              that.antvButton = false;
              that.selectedInstanceId = 0;
              that.selectedProxyId = 0;
              that.renderGraph.findAll('node', (node) => {
                if (node.get('model').id != "x") {
                  that.renderGraph.showItem(node)
                }
                return true;
              });
              that.showAntv = true;
            }
          }
        )
        ;
      }
    },

    beforeDestroy() {
      this.$notify.closeAll();
    }
  }
</script>

<style>
  .notifyStyle {
    width: auto;
  }
</style>

<style scoped>
  /*.arrow-container {*/
  /*  background-color: #ecf5ff;*/
  /*  border-radius: 10px;*/
  /*  padding: 5px;*/
  /*  display: flex;*/
  /*  flex-direction: column;*/
  /*  justify-content: center;*/
  /*  position: fixed;*/
  /*  right: 0;*/
  /*  margin-right: 5px;*/
  /*  bottom: 0;*/
  /*  margin-bottom: 10px;*/
  /*  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.5);*/
  /*  z-index: 10;*/
  /*  cursor: move;*/
  /*}*/

  .collapse-title {
    flex: 1 1 auto;
    order: 1;
    font-size: 17px;
  }

  /*.bj{*/
  /*  background:url("../../../../src/assets/butel.png");*/
  /*  background-size: 100% 100%;*/
  /*}*/
  /*/deep/ .el-card__header{*/
  /*  padding:10px   10px;*/
  /*  color: #0000cc;*/
  /*}*/
  /deep/ .el-card__body {
    padding: 5px 10px;
  }

  /* .el-checkbox__label {*/
  /*  display: inline-block;*/
  /*  padding-left: 10px;*/
  /*  padding-right: 10px;*/
  /*  line-height: 30px;*/
  /*  border-radius: 20px;*/
  /*  font-size: 14px;*/
  /*  border: 1px solid;*/
  /*}*/
  /*  .el-checkbox__input.is-disabled + span.el-checkbox__label {*/
  /*    color: #090909;*/
  /*    cursor: not-allowed;*/
  /*  }*/
</style>
